export Number from './number';
export Input from './input';



// WEBPACK FOOTER //
// ./src/input/index.js